<template>
  <div id="navbar-page">
    <nav :class="classNavbar">
      <div
        :class="[{ 'd-block': menuActive }, backMenuClass]"
        @click="openMenu"
      />
      <div class="container">
        <div class="navbar-left mr-1 w-15 mt-2">
          <button type="button" class="navbar-toggler mr-0" v-b-toggle.sidebar-nav-page>&#9776;</button>
          <a class="navbar-brand px-xs-0" href="`${protocol}${path}`">
            <img
              :src="currentScopedCompanyPage.icon_logo && currentScopedCompanyPage.icon_logo.url"
              alt="logo"
            >
          </a>
        </div>

        <section class="navbar-mobile">
          <span class="navbar-divider d-mobile-none" />
          <!-- Content visible pages show company (not logged). - <EMPRESA>.abler.com.br -->
          <menu-logged-out v-if="!userIsLoggedIn" :current-scoped-company-page="currentScopedCompanyPage" />
          <!-- Content visible pages show company (company - logged). - <EMPRESA>.abler.com.br -->
          <menu-logged-in v-if="userIsLoggedIn" :current-scoped-company-page="currentScopedCompanyPage" />
          <!-- Social Media Icons. - <EMPRESA>.abler.com.br -->
          <social-media-icons :current-scoped-company-page="currentScopedCompanyPage" />
        </section>

        <div class="col">
          <div
            v-if="!userIsLoggedIn"
            class="pull-right"
          >
            <!-- button when show 'company page' -->
            <a
              :href="signInUrl(currentScopedCompanySubdomain)"
              class="btn btn-xs btn-outline-light btn-round ml-lg-5 mr-2"
              :class="{'d-none d-md-block': subdomain == 'empresas'}"
            >
              {{ textButton }}
            </a>
          </div>

          <!-- Candidate Logged -->
          <ul
            v-if="currentUserIsCandidate"
            class="nav nav-navbar nav-transform-none pull-right"
          >
            <li
              class="nav-item mx-0"
              @click="openNavUser"
            >
              <span
                class="nav-link right-mobile"
                style="width: 50px"
              >
                <img
                  class="avatar"
                  style="width: 30px; height: 30px;"
                  :src="currentUser.picture && currentUser.picture.url"
                >
              </span>
              <nav :class="[{ 'd-block': isActive }, childNavClass]">
                <a
                  class="nav-link"
                  :href="`${protocol}candidatos.${currentdomain}/app/profile`"
                >
                  <i
                    class="fa fa-user"
                    aria-hidden="true"
                  />
                  Meu perfil
                </a>
                <a
                  class="nav-link"
                  :href="`${protocol}candidatos.${currentdomain}/app/applications`"
                >
                  <i
                    class="fa fa-thumb-tack"
                    aria-hidden="true"
                  />
                  Minhas candidaturas
                </a>
                <a
                  class="nav-link text-danger"
                  href="#"
                  @click.prevent="logout"
                >
                  <i class="fas fa-sign-out-alt" />
                  Sair
                </a>
              </nav>
            </li>
          </ul>

          <!-- Company Logged -->
          <ul
            v-if="currentUserIsCompanyUser"
            class="nav nav-navbar nav-transform-none pull-right"
          >
            <li
              class="nav-item mx-0"
              @click="openNavUser"
            >
              <span
                class="nav-link right-mobile"
                style="width: 68px"
              >
                <img
                  class="avatar"
                  style="width: 30px; height: 30px;"
                  :src="currentScopedCompanyPage.avatar && currentScopedCompanyPage.avatar.url"
                >
              </span>
              <nav
                :class="[{ 'd-block': isActive }, childNavClass]"
              >
                <a
                  class="nav-link"
                  :href="`${protocol}${currentUser.subdomain}.${currentdomain}/app/empresas/${currentScopedCompany.id}`"
                >
                  <i
                    class="fa fa-building"
                    aria-hidden="true"
                  />
                  Minha empresa
                </a>
                <a
                  class="nav-link"
                  :href="`${protocol}${currentUser.subdomain}.${currentdomain}/app/empresas/${currentScopedCompany.id}/painel`"
                >
                  <i class="fas fa-cubes" />
                  Configurações
                </a>
                <a
                  class="nav-link text-danger"
                  href="#"
                  @click.prevent="logout"
                >
                  <i class="fas fa-sign-out-alt" />
                  Sair
                </a>
              </nav>
            </li>
          </ul>

          <!-- Admin Logged -->
          <ul
            v-if="currentUserIsAdmin"
            class="nav nav-navbar nav-transform-none pull-right"
          >
            <li
              class="nav-item mx-0"
              @click="openNavUser"
            >
              <span
                class="nav-link right-mobile pl-0"
                style="width: 52px"
              >
                <img
                  class="avatar"
                  style="width: 30px; height: 30px;"
                  src="../assets/landings/avatar/iconic_abler.jpg"
                >
              </span>
              <nav :class="[{ 'd-block': isActive }, childNavClass]">
                <a
                  class="nav-link"
                  :href="`${protocol}admin.${currentdomain}/app`"
                >
                  <i class="fas fa-columns" />
                  Painel
                </a>
                <a
                  class="nav-link text-danger"
                  @click.prevent="logout"
                  href="#"
                >
                  <i class="fas fa-sign-out-alt" />
                  Sair
                </a>
              </nav>
            </li>
          </ul>
        </div>
      </div>
    </nav><!-- /.navbar -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import mixins from '../mixins/mixins';
import menuLoggedOut from './navbar/menu-logged-out.vue';
import menuLoggedIn from './navbar/menu-logged-in.vue';
import SocialMediaIcons from './navbar/social-media-icons.vue';

export default {
  name: 'NavbarPage',
  mixins: [mixins],
  components: {
    menuLoggedOut,
    menuLoggedIn,
    SocialMediaIcons,
  },
  data() {
    return {
      textButton: '',
      currentdomain: '',
      separate: window.location.host.split('.'),
      companyBrand: '',
      isActive: false,
      childNavClass: {
        nav: true,
        'nav-user': true,
      },
      menuActive: false,
      backMenuClass: {
        backdrop: true,
        'backdrop-navbar': true,
      },
      classNavbar: {
        navbar: true,
        'navbar-expand-lg': true,
        'navbar-light': false,
        'navbar-light': window.location.host.split('.')[0] !== 'candidatos' || window.location.host.split('.')[0] !== 'empresas',
        'navbar-dark': window.location.host.split('.')[0] === 'empresas',
      },
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
      'currentScopedCompanyPage',
      'currentScopedCompanySubdomain',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'currentUserIsCandidate',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
    ]),
    ...mapState('VacancyStore', [
      'vacancy',
      'vacLoading',
    ]),
  },
  mounted() {
    this.separate.shift();
    this.currentdomain = this.separate.join('.');
    this.textButton = this.pathSplit[0] === 'empresas' ? 'Login Empresa' : 'Login Candidato';
  },
  methods: {
    signInUrl(currentScopedCompanySubdomain) {
      let url = `${this.protocol}candidatos.${this.currentdomain}/sign-in`;
      let params = [];
      if(currentScopedCompanySubdomain.subdomain) {
        params.push(`subdomain=${currentScopedCompanySubdomain.subdomain}`)
      }
      if(this.vacancy.vacancy) {
        params.push(`slug=${this.vacancy.vacancy[JSON.parse(Object.keys(this.vacancy.vacancy))].attributes.slug}`);
      }
      if(params.length) {
        url += `?${params.join('&')}`
      }
      return url;
    },
    logout() {
      this.$store.dispatch('UserStore/logout').then(
        response => {
          window.location.href = '/';
        },
      );
    },
    openMenu() {
      this.menuActive = !this.menuActive;
    },
    openNavUser() {
      this.isActive = !this.isActive;
    },
    isEmpty(value) {
      return value === '' || value === null;
    },
  },
};
</script>

<style lang="scss" scoped>
  @use '../assets/stylesheet/variables.scss' as *;
  #navbar-page {
    .navbar.navbar-expand-lg.navbar-light {
      z-index: 2;
    }

    .right-mobile {
      @media screen and (max-width: 991px) {
        float: right;
      }
    }
    .nav.nav-user {
      @media screen and (max-width: 991px) {
        position: absolute;
        top: 50px;
        right: 10px;
      }
    }

    .backdrop.backdrop-navbar {
      background-color: rgba(255, 255, 255, 0.38);
      display: none;
    }

    .pull-right {
      .btn.btn-xs.btn-outline-light {
        @media screen and (max-width: 576px) {
          font-size: 8px;
        }
      }
    }

    @media only screen and (min-width : 320px) and (max-width: 768px) {
      .pr-xs-0,
      .px-xs-0 {
        padding-right: 0 !important;
      }
      .pl-xs-0,
      .px-xs-0 {
        padding-left: 0 !important;
      }
    }
  }

  .navbar .container .col > .nav > .nav-item > .nav-user {
    right: 0;
  }

  @media (max-width: 991.98px) {
    .navbar-expand-lg .navbar-mobile .btn-outline-light {
      color: $abler_secondary;
      background-color: transparent;
      background-image: none;
      border-color: $abler_secondary;
    }
  }
</style>
